import {Theme, createStyles} from '@material-ui/core';

export const mapStyles = (theme: Theme) =>
	createStyles({
		mapAporia: {
			width: '100%',
			marginBottom: theme.typography.pxToRem(26),
			[theme.breakpoints.down('xs')]: {
				width: '80%',
			},
			[theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.sm)]: {
				width: '70%',
			},
		},
		description: {
			textAlign: 'center',
			textTransform: 'uppercase',
			fontSize: theme.typography.pxToRem(20),
			lineHeight: theme.typography.pxToRem(26),
			letterSpacing: '0.08em',
			color: theme.palette.primary.main,
			fontFamily: 'GolosTextWebBlack',
			margin: 0,
			marginBottom: theme.typography.pxToRem(20),
			[theme.breakpoints.down('xs')]: {
				padding: theme.spacing(0, 8),
				marginBottom: theme.typography.pxToRem(10),
			},
			[theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.sm)]: {
				padding: theme.spacing(0, 0),
				fontSize: theme.typography.pxToRem(18),
			},
		},
		mapWrapper: {
			textAlign: 'center',
		},
		email: {
			display: 'inline-block',
			lineHeight: theme.typography.pxToRem(22),
			fontSize: theme.typography.pxToRem(16),
			padding: theme.spacing(0, 0.2),
			marginBottom: theme.spacing(3),
			borderBottomWidth: 1,
			borderBottomStyle: 'solid',
			borderBottomColor: theme.palette.text.footerLinkBorder,
			color: theme.palette.text.footerLink,
			[theme.breakpoints.between(theme.breakpoints.values.xs, theme.breakpoints.values.sm)]: {
				fontSize: theme.typography.pxToRem(16),
			},
		},
	});
